import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

function resolve(obj, path) {
  return path.split(".").reduce((acc, k) => (acc == null ? acc : acc[k]), obj);
}

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "en";
    return localStorage.getItem("rexxind-lang") || "en";
  });

  useEffect(() => {
    localStorage.setItem("rexxind-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (path) => {
    const val = resolve(translations[lang], path);
    if (val === undefined) return resolve(translations.en, path);
    return val;
  };

  const toggle = () => setLang((l) => (l === "en" ? "it" : "en"));

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useI18n() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useI18n must be used within LanguageProvider");
  return ctx;
}
